require('normalize.css');
require('./styles/index.scss');

// Copy-to-clipboard for the support email (works without a mail client).
document.addEventListener('DOMContentLoaded', function () {
  // Dynamic copyright year
  var y = document.getElementById('year');
  if (y) { y.textContent = new Date().getFullYear(); }

  // Language menu (<details class="langsw">): close when clicking elsewhere or pressing Esc.
  function closeLangMenus(except) {
    document.querySelectorAll('details.langsw[open]').forEach(function (d) {
      if (d !== except) { d.removeAttribute('open'); }
    });
  }
  document.addEventListener('click', function (e) {
    var inside = e.target.closest ? e.target.closest('details.langsw') : null;
    closeLangMenus(inside);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeLangMenus(null); }
  });

  // Demo videos (src/lib/video.js): swap the poster for the privacy-enhanced player on click.
  document.querySelectorAll('.vidplay[data-yt]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      e.preventDefault();
      var f = document.createElement('iframe');
      f.src = 'https://www.youtube-nocookie.com/embed/' + a.getAttribute('data-yt') + '?autoplay=1&rel=0';
      f.title = a.getAttribute('data-title');
      f.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
      f.allowFullscreen = true;
      a.replaceWith(f);
    });
  });

  document.querySelectorAll('.copybtn').forEach(function (b) {
    b.addEventListener('click', async function () {
      var v = b.getAttribute('data-copy');
      try {
        await navigator.clipboard.writeText(v);
      } catch (e) {
        var t = document.createElement('textarea');
        t.value = v;
        document.body.appendChild(t);
        t.select();
        document.execCommand('copy');
        t.remove();
      }
      var o = b.textContent;
      // Localized pages set data-copied (e.g. the Japanese footer); default is English.
      b.textContent = b.getAttribute('data-copied') || 'Copied ✓';
      setTimeout(function () { b.textContent = o; }, 1500);
    });
  });
});
